import React from 'react';
import { FileIcon } from 'elements/Icon';

const Audio = () => (
  <FileIcon>
    <path d="M98,2v136H2V2L98,2 M100,0H0v140h100V0L100,0z" />
    <g transform="translate(0,-952.36218)">
      <path d="M25.873,995.815c-1.273,0-2.354,1.08-2.354,2.354v3.531c0,1.273,1.08,2.354,2.354,2.354v27.051
        c0,1.341,1.165,2.372,2.409,2.372h13.02l-4.156,12.983c-0.378,0.899,0.043,1.934,0.942,2.312s1.934-0.043,2.312-0.942
		c0.039-0.092,0.07-0.188,0.093-0.286l1.857-5.829h15.3l1.857,5.829c0.221,0.95,1.17,1.541,2.119,1.32
		c0.95-0.221,1.541-1.17,1.32-2.119c-0.023-0.098-0.054-0.193-0.093-0.286l-4.156-12.983h13.02c1.244,0,2.409-1.032,2.409-2.372
		v-27.051c1.273,0,2.354-1.08,2.354-2.354v-3.531c0-1.273-1.08-2.354-2.354-2.354H25.873V995.815z M27.05,999.345h45.9v1.177h-45.9
		V999.345z M29.404,1004.053h41.192v25.892H29.404V1004.053z M44.998,1033.476h10.004l1.508,4.708H43.49L44.998,1033.476z"/>
</g>
  </FileIcon>
);

export default Audio;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/types/Presentation.jsx